class PaymentValidationService {
  private _paymentEmail: string;
  private _paymentPhone: string;
  private _isPaymentEmailValid: boolean;
  private _isPaymentPhoneValid: boolean;
  private _isPaymentEmailUpdateChecked: boolean;
  private _isPaymentPhoneUpdateChecked: boolean;
  //bookedBy------------------------------------------
  private _bookedByPaymentEmail: string;
  private _bookedByPaymentPhone: string;
  private _isBookedByPaymentEmailValid: boolean;
  private _isBookedByPaymentPhoneValid: boolean;
  private _isBookedByPaymentEmailUpdateChecked: boolean;
  private _isBookedByPaymentPhoneUpdateChecked: boolean;
  private _validationCallback: (isPaymentEmailValid: boolean, isPaymentPhoneValid: boolean) => void;

  public init(paymentEmail?: string, paymentPhone?: string, validationCallback?: (isPaymentEmailValid: boolean, isPaymentPhoneValid: boolean) => void, bookedByPaymentEmail?: string, bookedByPaymentPhone?: string,): void {
    this._paymentEmail = paymentEmail || '';
    this._paymentPhone = paymentPhone || '';
    this._isPaymentEmailValid = true;
    this._isPaymentPhoneValid = true;
    this._isPaymentEmailUpdateChecked = false;
    this._isPaymentPhoneUpdateChecked = false;
    //bookedBy------------------------------------------
    this._bookedByPaymentEmail = bookedByPaymentEmail || '';
    this._bookedByPaymentPhone = bookedByPaymentPhone || '';
    this._isBookedByPaymentEmailValid = true;
    this._isBookedByPaymentPhoneValid = true;
    this._isBookedByPaymentEmailUpdateChecked = false;
    this._isBookedByPaymentPhoneUpdateChecked = false;
    this._validationCallback = validationCallback || (() => {});
  }

  get paymentEmail(): string {
    return this._paymentEmail;
  }

  set paymentEmail(value: string) {
    this._paymentEmail = value;
  }

  get paymentPhone(): string {
    return this._paymentPhone;
  }

  set paymentPhone(value: string) {
    this._paymentPhone = value;
  }

  get isPaymentEmailValid(): boolean {
    return this._isPaymentEmailValid;
  }

  set isPaymentEmailValid(value: boolean) {
    this._isPaymentEmailValid = value;
    this._validationCallback(this._isPaymentEmailValid, this._isPaymentPhoneValid);
  }

  get isPaymentPhoneValid(): boolean {
    return this._isPaymentPhoneValid;
  }

  set isPaymentPhoneValid(value: boolean) {
    this._isPaymentPhoneValid = value;
    this._validationCallback(this._isPaymentEmailValid, this._isPaymentPhoneValid);
  }

  get isPaymentEmailUpdateChecked(): boolean {
    return this._isPaymentEmailUpdateChecked;
  }

  set isPaymentEmailUpdateChecked(value: boolean) {
    this._isPaymentEmailUpdateChecked = value;
  }

  get isPaymentPhoneUpdateChecked(): boolean {
    return this._isPaymentPhoneUpdateChecked;
  }

  set isPaymentPhoneUpdateChecked(value: boolean) {
    this._isPaymentPhoneUpdateChecked = value;
  }
  get bookedByPaymentEmail(): string {
    return this._bookedByPaymentEmail;
  }
  set bookedByPaymentEmail(value: string) {
    this._bookedByPaymentEmail = value;
  }
  get bookedByPaymentPhone(): string {
    return this._bookedByPaymentPhone;
  }
  set bookedByPaymentPhone(value: string) {
    this._bookedByPaymentPhone = value;
  }
  get isBookedByPaymentEmailValid(): boolean {
    return this._isBookedByPaymentEmailValid;
  }
  set isBookedByPaymentEmailValid(value: boolean) {
    this._isBookedByPaymentEmailValid = value;
  }
  get isBookedByPaymentPhoneValid(): boolean {
    return this._isBookedByPaymentPhoneValid;
  }
  set isBookedByPaymentPhoneValid(value: boolean) {
    this._isBookedByPaymentPhoneValid = value;
  }
  get isBookedByPaymentEmailUpdateChecked(): boolean {
    return this._isBookedByPaymentEmailUpdateChecked;
  }
  set isBookedByPaymentEmailUpdateChecked(value: boolean) {
    this._isBookedByPaymentEmailUpdateChecked = value;
  }
  get isBookedByPaymentPhoneUpdateChecked(): boolean {
    return this._isBookedByPaymentPhoneUpdateChecked;
  }
  set isBookedByPaymentPhoneUpdateChecked(value: boolean) {
    this._isBookedByPaymentPhoneUpdateChecked = value;
  }
}
const instance = new PaymentValidationService();
export default instance;
